










































import { CommerceParams } from '@/store/interfaces/commerce';
import commerceTypes from '@/store/types/commerce';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default Vue.extend({
  name: 'Commerces',
  data: () => ({
    propsToSearch: ['name_cont'] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'name',
        label: '', // Assigned in created function
        minWidth: 250,
        sortable: true,
      },
      {
        prop: 'commerce_kind.name',
        label: 'Tipo',
        minWidth: 220,
        sortable: true,
      },
      {
        prop: 'description',
        label: 'Descripción',
        minWidth: 220,
        sortable: true,
      }
    ] as tTableColumns,
    rowSelected: {},
  }),
  created() {
    this.tableColumns[0].label = `Nombre del ${this.$t('menu.commerce.singular.informal')}`;
  },
  computed: {
    ...mapGetters({
      getCommerceList: `commerceModule/${commerceTypes.getters.GET_COMMERCES}`,
    }),
  },
  methods: {
    ...mapActions({
      commerceList: `commerceModule/${commerceTypes.actions.COMMERCE_LIST}`,
    }),
    ...mapMutations({
      setSingleCommerce: `commerceModule/${commerceTypes.mutations.SET_SINGLE_COMMERCE}`,
    }),
    rowselect(row: CommerceParams): void {
      this.setSingleCommerce(row);
      this.$data.rowSelected = row;
    },
    commercesDetail(): void {
      this.$router.push({
        name: 'partners-profile',
        params: {
          commerce_id: this.$data.rowSelected.id,
        },
      });
    },
  },
});
